@if (isOpen()) {
  <div
    class="modal-backdrop"
    (click)="onBackdropClick($event)"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h2>{{ translateService.getTranslation(161) }}</h2>
        <button
          class="close-btn"
          (click)="close()"
        >
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>

      <div class="modal-body">
        <div class="form-field">
          <label>{{ translateService.getTranslation(4141) }}</label>
          <input
            type="text"
            [placeholder]="translateService.getTranslation(4141)"
            [ngModel]="groupName()"
            (ngModelChange)="groupName.set($event)"
          />
        </div>

        <div class="form-field">
          <label>{{ translateService.getTranslation(4143) }}</label>
          <input
            type="text"
            [placeholder]="translateService.getTranslation(4155)"
            [ngModel]="searchText()"
            (ngModelChange)="onSearchChange($event)"
          />

          @if (searchResults().length > 0) {
            <div class="search-dropdown">
              @for (user of searchResults(); track user.userId) {
                <div
                  class="dropdown-item"
                  (click)="selectUser(user)"
                >
                  {{ user.userName }}
                </div>
              }
            </div>
          }
        </div>

        @if (selectedMembers().length > 0) {
          <div class="member-chips">
            @for (member of selectedMembers(); track member.userId) {
              <span class="chip">
                <button
                  class="chip-remove"
                  (click)="removeMember(member.userId)"
                >
                  ×
                </button>
                {{ member.userName }}
              </span>
            }
          </div>
        }
      </div>

      <div class="modal-footer">
        <button
          class="btn-cancel"
          (click)="close()"
        >
          {{ translateService.getTranslation(49) }}
        </button>
        <button
          class="btn-primary"
          (click)="onSubmit()"
          [disabled]="!groupName().trim()"
        >
          {{ translateService.getTranslation(1721) }}
        </button>
      </div>
    </div>
  </div>
}
